import { render } from "./ModalEditCustomer.vue?vue&type=template&id=6dd2b51d&scoped=true"
import script from "./ModalEditCustomer.vue?vue&type=script&lang=js"
export * from "./ModalEditCustomer.vue?vue&type=script&lang=js"

import "./ModalEditCustomer.vue?vue&type=style&index=0&id=6dd2b51d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd2b51d"]])

export default __exports__